import React from 'react';
import {Input, DatePicker, Wysiwyg, Dropdown, Checkbox} from '../../form'
import {FormTemplateField} from '../../others/'
import {FAMILY_RELATIONS_AND_SELF} from '../../Constants'
import { Field } from 'redux-form';

const TermOfServiceTab = (props)=> {
  const {template, isTemplate} = props
  return(
    <div className="term-of-service pb-8">
      {template && template.terms_of_service &&
        <div className="row mx-0 mt-7 pb-7 bg-white shadow-sm rounded">
          <div className="col-12 px-7 mt-5">
            {/*<p>Last Updated: April 19, 2019 </p>*/}
          </div>
          <FormTemplateField
            isTemplate={isTemplate}
            fieldValues={template.terms_of_service.fields.hippa_policy}
            component={Wysiwyg}
            type="wysiwyg"
            toolbarClassName="toolbarClassName bg-light"
            wrapperClasses="col-12 px-7 mb-7"
            wrapperClassName="border border-muted rounded"
            editorClassName="bg-white px-5 wysiwyg-editor"
            baseName="terms_of_service[fields][hippa_policy]"
            hideIsRequired={true}
           />

          <FormTemplateField
            isTemplate={isTemplate}
            fieldValues={template.terms_of_service.fields.office_policy}
            component={Wysiwyg}
            type="wysiwyg"
            toolbarClassName="toolbarClassName bg-light"
            wrapperClasses="col-12 px-7 mb-7"
            wrapperClassName="border border-muted rounded"
            editorClassName="bg-white px-5 wysiwyg-editor"
            baseName="terms_of_service[fields][office_policy]"
            hideIsRequired={true}
           />

          <FormTemplateField
            isTemplate={isTemplate}
            fieldValues={template.terms_of_service.fields.other_policy}
            component={Wysiwyg}
            type="wysiwyg"
            toolbarClassName="toolbarClassName bg-light"
            wrapperClasses="col-12 px-7 mb-7"
            wrapperClassName="border border-muted rounded"
            editorClassName="bg-white px-5 wysiwyg-editor"
            baseName="terms_of_service[fields][other_policy]"
            hideIsRequired={true}
           />

          <Field
            // isTemplate={isTemplate}
            // fieldValues={template.terms_of_service.fields.tos}
            label="I have read and accept the above terms and conditions."
            component={Checkbox}
            wrapperClasses="col-12 px-7 my-7 label-icons form-group"
            // baseName="terms_of_service[fields][sign_date]"
            name="tos_info[is_tos_signed]"
           />

          <FormTemplateField
            isTemplate={isTemplate}
            fieldValues={template.terms_of_service.fields.sign_date}
            component={DatePicker}
            wrapperClasses="col-6 px-7 mb-7 label-icons form-group"
            baseName="terms_of_service[fields][sign_date]"
            name="tos_info[sign_date]"
            hideIsRequired={true}
           />

          <FormTemplateField
            isTemplate={isTemplate}
            isOpen={true}
            fieldValues={template.terms_of_service.fields.signee_name}
            component={Input}
            className="form-control"
            wrapperClasses="col-6 px-7 mb-7 form-group"
            baseName="terms_of_service[fields][signee_name]"
            name="tos_info[signee_name]"
            hideIsRequired={true}
           />

          <FormTemplateField
            isTemplate={isTemplate}
            isOpen={true}
            name="tos_info[signee_relation]"
            baseName="terms_of_service[fields][signee_relation]"
            fieldValues={template.terms_of_service.fields.signee_relation}
            component={Dropdown}
            data={FAMILY_RELATIONS_AND_SELF}
            valueField="value"
            textField="label"
            wrapperClasses="col-6 px-7 mb-7 form-group"
            hideIsRequired={true}
          />


          {/* <FormTemplateField
            isTemplate={isTemplate}
            fieldValues={template.terms_of_service.fields.signature}
            component={Input}
            className="form-control"
            wrapperClasses="col-6 px-7 mb-7 form-group"
            baseName="terms_of_service[fields][signature]"
            name="tos_info[signature]"
           /> */}

          <FormTemplateField
            isTemplate={isTemplate}
            isOpen={true}
            fieldValues={template.terms_of_service.fields.signature}
            component={Input}
            className="form-control signature"
            wrapperClasses="col-6 px-7 mb-7 form-group"
            baseName="terms_of_service[fields][signature]"
            name="tos_info[signee_name]"
            hideIsRequired={true}
           />

        </div>
      }
    </div>
  )
}

export default TermOfServiceTab;
